export class GroupHeader {
  public collapsed = false;

  constructor(public readonly name: string) {}
}
